import { theme } from '@theme';
import { FC } from 'react';
import TryAgain from '../../../../shared/try-again/TryAgain';
import { Typography } from '../../../../style';

type PortfolioTryAgainProps = {
  retry: () => void;
};

const PortfolioTryAgain: FC<PortfolioTryAgainProps> = ({ retry }) => {
  const bodyComponent: JSX.Element = (
    <>
      <Typography
        className='try-again-header'
        size={theme.typography.h2}
        fontWeight={theme.typography.fontWeights.semibold}
        color={theme.palette.basicGray}
      >
        There was a difficulty loading data
      </Typography>
      <br></br>
      <Typography
        className='try-again-text'
        size={theme.typography.h4}
        fontWeight={theme.typography.fontWeights.normal}
        color={theme.palette.dusty}
      >
        It can be an issue with your connectivity or our site maintenance..
      </Typography>
    </>
  );
  return <TryAgain retry={retry} bodyComponent={bodyComponent} />;
};

export default PortfolioTryAgain;
